import { CopyButton } from "./AdminUi";
import { Modal } from "./Modal";

export function ScimSecretDialog({
  endpoint,
  token,
  onClear,
}: {
  endpoint: string;
  token: string;
  onClear: () => void;
}) {
  return (
    <Modal
      closeDisabled
      eyebrow="Sensitive credential"
      title="SCIM token"
      titleId="scim-secret-dialog-title"
    >
      <div className="secret-dialog__body">
        <div className="notice notice--warning">
          <strong>Secret access recorded.</strong> This reveal was written to
          the audit log. Clear it from the screen when finished.
        </div>
        <label>
          <span>SCIM endpoint</span>
          <div className="copy-value">
            <code>{endpoint}</code>
            <CopyButton label="Copy endpoint" value={endpoint} />
          </div>
        </label>
        <label>
          <span>SCIM token</span>
          <div className="copy-value copy-value--secret">
            <code>{token}</code>
            <CopyButton label="Copy token" value={token} />
          </div>
        </label>
        <button
          className="button button--primary button--large"
          onClick={onClear}
          type="button"
        >
          Clear token from screen
        </button>
      </div>
    </Modal>
  );
}
